// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Hongkong from '../_raw/flag/icon_flag_hongkong.png';

export default () => <img src={Hongkong} alt="Hongkong" />;
